module.exports = __webpack_public_path__ + "static/media/features-split-image-02.e4999bb7.png";